interface SpinnerProps {
    message?: string;
  }
  
  const Spinner = ({ message = 'Uploading...' }: SpinnerProps) => {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        {/* Overlay */}
        <div className="absolute inset-0 bg-white/50 backdrop-blur-sm"></div>
        
        {/* Spinner Content */}
        <div className="z-50 flex flex-col items-center">
          <div className="relative">
            <div 
              className="h-16 w-16 rounded-full border-4 border-gray-200 animate-spin"
              style={{ borderTopColor: '#3B82F6' }}
            />
          </div>
          <div className="mt-4 text-center text-gray-700 font-semibold">{message}</div>
          <div className="mt-2 text-center text-gray-500 text-sm">Please wait...</div>
        </div>
      </div>
    );
  };
  
  export default Spinner;